import { render, staticRenderFns } from "./CardTicketTask.vue?vue&type=template&id=4711f841&"
import script from "./CardTicketTask.vue?vue&type=script&lang=js&"
export * from "./CardTicketTask.vue?vue&type=script&lang=js&"
import style0 from "./CardTicketTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports